import {kHomeFooterLegalNavItems} from "../../../constants/navigation";
import HomeFooterNavigationItem from "../../items/homeScreen/HomeFooterNavigationItem";

export default function HomeFooterLegalNavigationLinks() {
    // Used in HomeFooterBottomLinks to display list of legals internal links

    // BUILD
    return (
        <div className={"flex justify-start items-center space-x-[16px]"}>
            {kHomeFooterLegalNavItems.map((item, index) =>
                <HomeFooterNavigationItem item={item} key={index} />
            )}
        </div>
    )
}